import { useEffect } from "react";

const useBeforeUnload = (shouldWarn: boolean, excludedRoutePatterns: (string | RegExp)[] = []) => {

    useEffect(() => {
        const shouldSkip = excludedRoutePatterns.some((pattern) => {
            if (typeof pattern === 'string') {


                return window.location.pathname.includes(pattern);
            }
            if (pattern instanceof RegExp) {


                return pattern.test(window.location.pathname); 
            }
            return false; 
        });

        if (shouldWarn && !shouldSkip) {
            const handleBeforeUnload = (event: any) => {
                event.preventDefault();
                event.returnValue = ""; 
            };

            window.addEventListener("beforeunload", handleBeforeUnload);

            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
    }, [shouldWarn, excludedRoutePatterns, window.location.pathname]);
};

export default useBeforeUnload;